import React from 'react';
import SystemSettings from './SystemSettings';

const HamburgerMenu = ({ user, onClose }) => {
  return (
    <div className="h-full bg-green-50 overflow-y-auto">
      {/* Header */}
      <div className="p-6 border-b border-green-100 bg-white">
        <div className="flex items-start space-x-4">
          {/* Profile Picture */}
          <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center flex-shrink-0">
            <span className="text-2xl text-green-600">👤</span>
          </div>
          
          {/* User Info */}
          <div className="flex-1 min-w-0">
            <h2 className="text-xl font-bold text-gray-900 truncate">
              {user?.first_name || user?.firstName || 'User'} {user?.last_name || user?.lastName || ''}
            </h2>
            <p className="text-sm text-gray-500 mt-1">
              {user?.phone || user?.phoneNumber || ''}
            </p>
          </div>
        </div>
      </div>

      {/* System Settings */}
      <div className="py-6">
        <h3 className="text-lg font-bold text-gray-900 px-6 pb-3">
          System Settings
        </h3>
        <div className="bg-white">
          <SystemSettings user={user} />
        </div>
      </div>

      {/* Close button */}
      <button
        onClick={onClose}
        className="absolute top-6 right-6 w-10 h-10 flex items-center justify-center text-gray-400 hover:text-gray-600"
      >
        ✕
      </button>
    </div>
  );
};

export default HamburgerMenu;
